import React from 'react';

interface ProfileTabsProps {
  activeTab: 'posts' | 'media' | 'likes';
  setActiveTab: (tab: 'posts' | 'media' | 'likes') => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="flex space-x-8" aria-label="Tabs">
        <button
          onClick={() => setActiveTab('posts')}
          className={`py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === 'posts'
              ? 'border-domired-500 text-domired-600 dark:text-domired-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          Publicaciones
        </button>
        <button
          onClick={() => setActiveTab('media')}
          className={`py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === 'media'
              ? 'border-domired-500 text-domired-600 dark:text-domired-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          Fotos y Videos
        </button>
        <button
          onClick={() => setActiveTab('likes')}
          className={`py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === 'likes'
              ? 'border-domired-500 text-domired-600 dark:text-domired-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          Me gusta
        </button>
      </nav>
    </div>
  );
};

export default ProfileTabs;
